<template>
  <h1 v-if="user != null">Welcome {{ user.username }}</h1>
  <div class="grid-wrapper">
    <DxDataGrid :data-source="gridSource" ref="grid" v-if="true" :onEditorPreparing="onEditorPreparing"
      v-bind="getDefaultGridProperties()">
      <DxColumn data-field="IdUsuario" :allow-editing="false" :visible="false">
        <DxFormItem :visible="false"></DxFormItem>
        <DxRequiredRule />
      </DxColumn>
      <DxColumn data-field="UserName" :caption="$t('usuarios.grid.nombre_usuario')">
        <DxRequiredRule />
        <!--<DxAsyncRule :validation-callback="validarUsuario" message="El usuario ya existe"/>-->
      </DxColumn>
      <DxColumn data-field="Rol">
        <DxRequiredRule />
        <DxLookup :data-source="lookupRolesSource" value-expr="NormalizedName" display-expr="Name"
          :defer-rendering="false" :search-enabled="true" />
      </DxColumn>
      <DxColumn data-field="Nombre" sortOrder="asc" :sortIndex="0">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn data-field="Apellidos" sortOrder="asc" :sortIndex="1">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn data-field="Telefono" :allow-header-filtering="false" :allow-filtering="true">
      </DxColumn>
      <DxColumn data-field="Email">
        <DxRequiredRule />
        <DxEmailRule />
      </DxColumn>
      <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="true"
        :group-paging="true" />
      <DxEditing mode="popup" :allow-adding="true" :allow-updating="true" :allow-deleting="true" refresh-mode="reshape"
        v-if="tienePermisoUsuariosEditar(autho) || tienePermisoUsuariosEliminar(autho)">
        <DxTexts confirmDeleteMessage="¿Está seguro de que desea eliminar el usuario?">
        </DxTexts>
        <DxPopup height="400" width="500" :hide-on-outside-click="true" :show-close-button="true" :show-title="true"
          title="Formulario de usuario">
          <DxToolbarItem v-bind="makeEditPopupButton('Save', grid)"></DxToolbarItem>
          <DxToolbarItem v-bind="makeEditPopupButton('Cancel', grid)"></DxToolbarItem>
        </DxPopup>
      </DxEditing>

      <DxHeaderFilter :visible="true" />
      <DxFilterRow :visible="true" />
    </DxDataGrid>
  </div>
</template>


<script setup lang="ts">
import {
  DxAsyncRule, DxColumn, DxDataGrid, DxEditing, DxEmailRule, DxFormItem, DxRemoteOperations, DxRequiredRule,
  DxLookup, DxHeaderFilter, DxTexts, DxFilterRow, DxToolbarItem, DxPopup, DxGroupPanel
} from "devextreme-vue/data-grid";
import { makeEditPopupButton } from "@helpers/grid-helper";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from 'vue';
import type { RolesRm } from "@api/api"
import type { UserInfo } from '@/.shared/services/auth/authentication/authentication-service';
import { useApi } from "@/.shared/.api/integration";
import {
  getDefaultGridProperties
} from "@helpers/grid-helper";
import { tienePermisoUsuariosEditar, tienePermisoUsuariosEliminar } from "@/.shared/helpers/permission-helper";
import { useAuthorization } from "@/.shared/services/auth/authorization";
const api = useApi();
const autho = useAuthorization();

const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const lookupRolesSource = ref<RolesRm[]>();
const user = ref<UserInfo | null>();

const camposSoloAlta = ["UserName", "Email"];

onMounted(async () => {
  lookupRolesSource.value = await api.callStandardApi("rolesGetAll", {});

  gridSource.value = api.apiStore({
    key: "IdUsuario",
    load: await api.toStandardApiFunction("usuarioGetRejilla", { showLoading: false }),
    insert: await api.toStandardApiFunction("usuarioCreate", { showLoading: false }),
    update: async (key, values) => {
      await api.callStandardApi("usuarioEdit", { showLoading: false }, {
        IdUsuario: key,
        Rol: values.Rol,
        Nombre: values.Nombre,
        Apellidos: values.Apellidos,
        Telefono: values.Telefono
      });
    },
    remove: async (key) => {
      await api.callStandardApi("usuarioDelete", { showLoading: false }, {
        IdUsuario: key
      });
    },
  });

});

const onEditorPreparing = function (e: any) {
  if (e.parentType === "dataRow" && !camposSoloAlta.includes(e.dataField)) {
    return;
  }
  if (e.row) {
    if (!e.row.isNewRow)
      e.editorOptions.disabled = true;
  }
}

</script>